import useApi from "@/hooks/useApi";
import useAsync from "@/hooks/useAsync";
import IconActiveEngagements from "@/icons/IconActiveEngagements";
import IconRatings from "@/icons/IconRatings";
import IconTotalChats from "@/icons/IconTotalChats";
import React, { useCallback, useEffect, useState } from "react";
import { User } from "./types";
import { Avatar } from "@velaro/velaro-component-lib/";
import { SectionCard } from "@/components/ds";

interface Props {
  user: User | null;
}

export default function UserProfileBanner(props: Props) {
  const [activeChatCount, setActiveChatCount] = useState<number>(0);
  const [lastSevenDayChatCount, setLastSevenDayChatCount] = useState<number>(0);
  const api = useApi();

  const fetchActiveChatCount = useCallback(async () => {
    const response = await api.messaging.get(
      `Conversations/${props.user?.id}/Active`
    );
    if (!response.ok)
      throw new Error(
        `Failed to load active chat count: HTTP ${response.status}`
      );
    return await response.json();
  }, [api.messaging, props.user?.id]);

  useAsync({
    asyncFunction: fetchActiveChatCount,
    setFunction: setActiveChatCount,
    immediate: true
  });

  const fetchLastSevenDayChatCount = useCallback(async () => {
    const response = await api.messaging.get(
      `Conversations/${props.user?.id}/LastSevenDays`
    );
    if (!response.ok)
      throw new Error(
        `Failed to load last seven day chat count: HTTP ${response.status}`
      );
    return await response.json();
  }, [api.messaging, props.user?.id]);

  useAsync({
    asyncFunction: fetchLastSevenDayChatCount,
    setFunction: setLastSevenDayChatCount,
    immediate: true
  });

  return (
    <SectionCard className="!rounded-md !shadow-md border-none! mb-4 flex !p-4">
      <div className="flex justify-between w-full">
        <div className="flex items-center">
          <div className="w-12 h-12 relative z-0 grow-0 shrink-0">
            <Avatar
              name={
                props.user?.firstName && props.user?.lastName
                  ? `${props.user.firstName} ${props.user.lastName}`
                  : props.user?.displayName
              }
              url={props.user?.picture}
              size={40}
            />
            {/* <img
              src={props.user?.picture}
              alt=""
              className="rounded-full w-12 h-12 absolute z-10"
            /> */}
          </div>
          <div className="pl-4">
            <div className="font-bold">
              {props.user?.firstName + " " + props.user?.lastName}
            </div>
            <div className="text-sm text-zinc-500">
              {props.user?.licenseStatus}
            </div>
          </div>
        </div>
        <div className="flex gap-10">
          <div className="flex items-center">
            <IconActiveEngagements className="mr-2" />
            <div className="text-xs w-24">Total Active Engagements</div>
            <div className="text-2xl ml-2">{activeChatCount}</div>
          </div>
          <div className="flex items-center">
            <IconTotalChats className="mr-2" />
            <div className="text-xs w-20">Total Chats Last 7 Days</div>
            <div className="text-2xl ml-2">{lastSevenDayChatCount}</div>
          </div>
          {/* <div className="flex items-center">
            <IconRatings className="mr-2" />
            <div className="text-xs w-24">Average Ratings Last 7 Days</div>
            <div className="text-2xl ml-2">4.2</div>
          </div> */}
        </div>
      </div>
    </SectionCard>
  );
}
